import {vExpertizeBase} from '../database-models/v-expertize-base';
//Generated Imports
import { actionColumn } from '@rxweb/grid';
@actionColumn({
    name: 'action',
    allowSorting: false,
    configuredTemplate: { templateName: 'expertiseAction' }, columnIndex: 0, headerTitle: "Action", class: ["actionFild"],headerCellClass:["pl-4"]
})
export class vExpertize extends vExpertizeBase 
{




//#region Generated Reference Properties

//#endregion Generated Reference Properties














































}